import { render, staticRenderFns } from "./wxOpen.vue?vue&type=template&id=429243ee&scoped=true&lang=html"
import script from "./wxOpen.vue?vue&type=script&lang=js"
export * from "./wxOpen.vue?vue&type=script&lang=js"
import style0 from "./wxOpen.vue?vue&type=style&index=0&id=429243ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429243ee",
  null
  
)

export default component.exports